/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetBlueprintMetadataMetadataQueryResponse, AuditReportsGetBlueprintMetadataMetadataPathParams, AuditReportsGetBlueprintMetadataMetadataQueryParams, AuditReportsGetBlueprintMetadataMetadata400, AuditReportsGetBlueprintMetadataMetadata401, AuditReportsGetBlueprintMetadataMetadata403, AuditReportsGetBlueprintMetadataMetadata404 } from "../models/AuditReportsGetBlueprintMetadataMetadata";

export function getAuditReportsGetBlueprintMetadataMetadataUrl(reportType: AuditReportsGetBlueprintMetadataMetadataPathParams["reportType"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/report-blueprints/${reportType}` as const }
  return res
}

/**
 * @description Retrieves blueprint metadata (sections, categories, columns) for the specified report type. If blueprintVersion is provided, uses that version; otherwise uses the latest. The response excludes internal implementation details like extraction methods.
 * @summary Get blueprint metadata
 * {@link /audit-reports/v1/report-blueprints/:reportType}
 */
export async function auditReportsGetBlueprintMetadataMetadata(reportType: AuditReportsGetBlueprintMetadataMetadataPathParams["reportType"], params?: AuditReportsGetBlueprintMetadataMetadataQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetBlueprintMetadataMetadataQueryResponse, ResponseErrorConfig<AuditReportsGetBlueprintMetadataMetadata400 | AuditReportsGetBlueprintMetadataMetadata401 | AuditReportsGetBlueprintMetadataMetadata403 | AuditReportsGetBlueprintMetadataMetadata404>, unknown>({ method : "GET", url : getAuditReportsGetBlueprintMetadataMetadataUrl(reportType).url.toString(), params, ... requestConfig })
  return res.data
}